export default "__VITE_ASSET__Bj46Htz4__"